import axios from "axios";
import { toast } from 'react-toastify';
import Cookies from "js-cookie";

export const httpRequest = async (
    endpoint,
    method = "GET",
    body = {},
    queryParams = {},
    authentication = false,
    formData = false,
    responseType = "json",
    onUploadProgress = null,
    onDownloadProgress = null
) => {
    try {
        const config = {
           method: method.toUpperCase(),
           url: `${process.env.REACT_APP_API_URL}${endpoint}`,
           params: queryParams,
           data: body,
           headers: {},
           responseType: responseType,
        };

        if(formData) {
            config.headers["Content-Type"] = "multipart/form-data"
        } else {
            config.headers["Content-Type"] = "application/json"
        }

        if(authentication) {
            const token = Cookies.get("token");
            config.headers["Authorization"] = `Bearer ${token}`;
        }

        if (onUploadProgress) {
            config.onUploadProgress = onUploadProgress;
        }

        if (onDownloadProgress) {
            config.onDownloadProgress = onDownloadProgress;
        }

        const response = await axios(config);
console.log("response", response)
        return response.data;
    } catch(error) {
        if (error?.response?.status === 401) {
            Cookies.remove("token");
            if (typeof window !== "undefined") {
                window.location.href="/auth/login";
            }
            toast.error("Session expired. Please log in again.");
            return Promise.reject(error);
        }
        
        toast?.error(error?.response?.data?.message);
        // return false;
        throw error
    }
};

export const updateFormikValues = (data, formik, parentKey = '') => {
    if (typeof data !== 'object' || data === null) {
  
      return;
    }
  
    Object.keys(data).forEach((key) => {
      const fullKey = parentKey ? `${parentKey}.${key}` : key;
      const value = data[key];
    //   console.log("🚀 ~ Object.keys ~ fullKey:", value)
      if (value && typeof value === 'object') {
        // Recursively handle nested objects
        updateFormikValues(value, formik, fullKey);
      } else {
        // Directly update the formik values
        formik.setFieldValue(fullKey, value);
       
      }
    });
  };
  